export const typeToName = {
    date: 'Days',
    week: 'Weeks',
    month: 'Months'
};
export const formatError = 'Date range is in an invalid format';
export const mandatoryValuesError = 'Please select a date range';
export const messagePerType = {
    week: 'For more than 52 weeks switch to months'
};
export const navigatePrev = 'previous';
export const navigateNext = 'next';
export const presetsList = {
    date: [
        { name: 'Today', id: 'today', numid: 1 },
        { name: 'Yesterday', id: 'yesterday', numid: 2 },
        { name: 'Last 7 Days', id: 'last7days', numid: 3 },
        { name: 'Last 14 Days', id: 'last14days', numid: 4 },
        { name: 'This Month', id: 'thisMonth', numid: 5 },
        { name: 'Last Month', id: 'lastMonth', numid: 6 },
        { name: 'Last 30 Days', id: 'last30days', numid: 7 }
    ],
    'date1-7-14-30-90': [
        { name: 'Today', id: 'today', numid: 1 },
        { name: 'Yesterday', id: 'yesterday', numid: 2 },
        { name: 'Last 7 Days', id: 'last7days', numid: 3 },
        { name: 'Last 14 Days', id: 'last14days', numid: 4 },
        { name: 'This Month', id: 'thisMonth', numid: 5 },
        { name: 'Last Month', id: 'lastMonth', numid: 6 },
        { name: 'Last 30 Days', id: 'last30days', numid: 7 },
        { name: 'Last 90 Days', id: 'last90days', numid: 9 }
    ],
    'date7-14-30-60-90': [
        { name: 'Last 7 Days', id: 'last7days', numid: 3 },
        { name: 'Last 14 Days', id: 'last14days', numid: 4 },
        { name: 'Last 30 Days', id: 'last30days', numid: 7 },
        { name: 'Last 60 Days', id: 'last60days', numid: 8 },
        { name: 'Last 90 Days', id: 'last90days', numid: 9 }
    ],
    'date7-14-31-60-90': [
        { name: 'Last 7 Days', id: 'last7days', numid: 3 },
        { name: 'Last 14 Days', id: 'last14days', numid: 4 },
        { name: 'Last 31 days', id: 'last31days', numid: 10 },
        { name: 'Last 60 days', id: 'last60days', numid: 8 },
        { name: 'Last 90 days', id: 'last90days', numid: 9 }
    ],
    dateWithoutToday: [
        { name: 'Yesterday', id: 'yesterday', numid: 2 },
        { name: 'Last 7 Days', id: 'last7days', numid: 3 },
        { name: 'Last 14 Days', id: 'last14days', numid: 4 },
        { name: 'This Month', id: 'thisMonth', numid: 5 },
        { name: 'Last Month', id: 'lastMonth', numid: 6 },
        { name: 'Last 30 Days', id: 'last30days', numid: 7 }
    ],
    week: [
        { name: 'Last 4 Weeks', id: 'last4weeks', numid: 1 },
        { name: 'Last 12 Weeks', id: 'last12weeks', numid: 2 },
        { name: 'Last 26 Weeks', id: 'last26weeks', numid: 3 },
        { name: 'Last 52 Weeks', id: 'last52weeks', numid: 4 }
    ],
    month: [
        { name: 'Last 3 Months', id: 'last3months', numid: 1 },
        { name: 'Last 6 Months', id: 'last6months', numid: 2 },
        { name: 'Last 12 Months', id: 'last12months', numid: 3 },
        { name: 'Last 24 Months', id: 'last24months', numid: 4 },
        { name: 'Last 36 Months', id: 'last36months', numid: 5 }
    ]
};
